import { render, staticRenderFns } from "./ArchiveRecordPagination.vue?vue&type=template&id=1c56f545&scoped=true&"
import script from "./ArchiveRecordPagination.vue?vue&type=script&lang=js&"
export * from "./ArchiveRecordPagination.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveRecordPagination.vue?vue&type=style&index=0&id=1c56f545&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c56f545",
  null
  
)

export default component.exports